<div class="lg-snackbar">
    <div class="lg-snackbar__title">
        <span>{{ _title }}</span>
        @if (options.hideCloseButton !== true) {
            <lg-icon
                class="lg-snackbar__title__button"
                icon="icon-close"
                [clickable]="true"
                (click)="hide()"
            >
            </lg-icon>
        }
    </div>
    @if (_text) {
        <div class="lg-snackbar__text">{{ _text }}</div>
    }
    @if (options.buttons) {
        <div class="lg-snackbar__buttons">
            @for (button of options.buttons; track button) {
                <lg-button
                    buttonClass="button--condensed button--{{ button.style ?? 'primary' }}"
                    [text]="button.text"
                    [textLc]="button.textLc"
                    (click)="_onButtonClick(button)"
                >
                </lg-button>
            }
        </div>
    }
</div>
